var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressionUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 39,
    viewBox: "0 0 77 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5848 3.33256C76.7275 2.94369 76.5279 2.51279 76.139 2.37012L69.8021 0.0450578C69.4132 -0.0976195 68.9823 0.101955 68.8397 0.490821C68.697 0.879686 68.8966 1.31059 69.2854 1.45326L74.9182 3.51998L72.8515 9.1528C72.7088 9.54167 72.9084 9.97257 73.2973 10.1152C73.6861 10.2579 74.1171 10.0583 74.2597 9.66948L76.5848 3.33256ZM0.3125 38.0742L0.627702 38.7548L76.1959 3.75477L75.8807 3.07422L75.5655 2.39367L-0.00270191 37.3937L0.3125 38.0742Z",
    fill: "#53D769"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressionUpArrow);
export default __webpack_public_path__ + "static/media/progressionUpArrow.ce9c9f889edfddc7377593a61c120493.svg";
export { ForwardRef as ReactComponent };